export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14218.f3f6c446.jpg";